import React from 'react';
import { certTexts } from '../contexts/Lang1K';

function Product1KCertification({ certRef, certVisible, lang = 'ko', isMobile = false }) {
  return (
    <section
      ref={certRef}
      style={{
        width: '100vw',
        maxWidth: '100vw',
        background: '#e0e0e0', 
        borderRadius: 0,
        boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
        marginTop: isMobile ? 30 : 40,
        padding: isMobile ? '32px 20px' : '48px 40px',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start'
      }}
    >
      <span style={{
        fontSize: isMobile ? '1.6rem' : '2rem',
        fontWeight: 700,
        color: '#222', // 제목 색상 변경
        marginBottom: isMobile ? 20 : 16,
        textAlign: 'center', // 가운데 정렬 추가
        width: '100%'        // 부모 div 기준으로 가운데 정렬 적용

      }}>
        {certTexts.title[lang]}
      </span>
      <div style={{
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        flexWrap: isMobile ? 'nowrap' : 'wrap',
        gap: isMobile ? 24 : 40,
        alignItems: isMobile ? 'center' : 'flex-start', // 상단 정렬로 변경
        justifyContent: 'center',
        marginTop: isMobile ? 12 : 8,
        width: '100%',
      }}>
        {[
          { title: 'Presentation Attack Detection Level 2', img: require('../assets/images/1kosmos/pad2.png') },
          { title: 'SOC II Type 2', img: require('../assets/images/1kosmos/soc2.png') },
          { title: 'ISO 27001', img: require('../assets/images/1kosmos/iso27001.png') },
          { title: 'Full Service NIST 800-63-3', img: require('../assets/images/1kosmos/nist.png') },
          { title: 'FIDO2', img: require('../assets/images/1kosmos/fido2.png') },
          { title: 'FedRAMP High', img: require('../assets/images/1kosmos/fedramp.png') },
        ].map((item, idx) => (
          <div
            key={item.title}
            style={{
              textAlign: 'center',
              width: isMobile ? '100%' : 200,
              maxWidth: isMobile ? '280px' : '200px',
              transition: 'all 0.7s cubic-bezier(0.23, 1, 0.32, 1)',
              opacity: certVisible ? 1 : 0,
              transform: certVisible
                ? 'translateY(0)'
                : 'translateY(40px)',
              transitionDelay: certVisible ? `${idx * 0.12}s` : '0s',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'flex-start', // 상단 정렬로 변경
              padding: isMobile ? '16px' : '0',
              background: isMobile ? 'rgba(255,255,255,0.3)' : 'transparent',
              borderRadius: isMobile ? '12px' : '0',
              boxShadow: isMobile ? '0 2px 8px rgba(0,0,0,0.1)' : 'none'
            }}
          >
            <div style={{ 
              fontWeight: 600, 
              color: '#29225C', 
              marginBottom: isMobile ? 12 : 8,
              fontSize: isMobile ? '0.95rem' : '1rem',
              lineHeight: isMobile ? 1.4 : 1.2
            }}>{item.title}</div>
            <img
              src={item.img}
              alt={item.title}
              style={{
                width: 'auto',
                height: 'auto',
                maxWidth: isMobile ? '120px' : '100%',
                maxHeight: isMobile ? '80px' : '100%',
                display: 'block',
                margin: '0 auto',
                objectFit: 'contain'
              }}
            />
          </div>
        ))}
      </div>
    </section>
  );
}

export default Product1KCertification;